import VerticalImgUploader from '@common/VerticalImgUploader'
import { getImageAutoOrientLink } from '@util'
import { message } from 'hljd'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import { getText } from '../../utils'
import Item from '../Item'
import HeadImgList from './HeadImgList'
import styles from './style.module.less'
import UploadImg from './UploadImg'

@inject('centerStore', 'stepTwoStore')
@observer
export default class extends Component {
  onVerticalCliped = value => {
    const { property_id } = this.props.centerStore
    const limitHeight = property_id == 12 ? 702 : 540
    const limitWidth = property_id == 12 ? 526 : 540

    const { onValueChange } = this.props.stepTwoStore

    const { width, height } = value.pixel
    if (width < limitWidth || height < limitHeight) {
      return message.error(
        `图片宽度需大于${limitWidth}，高度需大于${limitHeight}`
      )
    }
    const clipUrl = getImageAutoOrientLink(value.clipUrl)
    onValueChange('vertical_image')({ clipUrl, pixel: value.pixel })
  }

  onVerticalDelete = () => {
    const { onValueChange } = this.props.stepTwoStore
    onValueChange('vertical_image')('')
  }

  render() {
    const { property_id, checkImg, isSingle } = this.props.centerStore
    let coverVerticalWidth = 540 // 封面方图宽度
    let coverVerticalHeight = 540 // 封面方图高度
    let headImgWidth = 1080 // 头图宽度
    let headImgHeight = 810 // 头图宽度
    // 横图尺寸
    const limitHeight = property_id == 12 ? 702 : 540
    const limitWidth = property_id == 12 ? 526 : 540

    let verticalImgText = '方图'

    if (property_id == 12) {
      // 婚纱礼服
      coverVerticalWidth = 526
      coverVerticalHeight = 702
      verticalImgText = '竖图'
      headImgWidth = 1080
      headImgHeight = 1440
    }

    if (isSingle) {
      headImgWidth = 1080
      headImgHeight = 1440
    }

    const {
      cover_path,
      vertical_image,
      onValueChange
    } = this.props.stepTwoStore

    const TEXT = getText()

    return (
      <Item label={`${TEXT}图片`} required>
        <div className={styles.tip}>
          <div>
            1.尺寸格式：封面横图 1080*675，{verticalImgText}{' '}
            {coverVerticalWidth}*{coverVerticalHeight}，头图
            {headImgWidth}*{headImgHeight}。大小不能超过 10 MB，支持 jpg、png 和
            bmp 等格式；
          </div>
          <div>
            2.封面：横图在{TEXT}列表和详情页头图的第一张展示，{verticalImgText}在首页推荐展示。更真实、直观地表达{
              TEXT
            }卖点，可快速提升成交转化；
          </div>
          <div>3.头图：建议上传 3 张以上，拖拽图片可以调整顺序；</div>
          <div>4.图片：需高清，不得添加任何文字、水印、logo 等；</div>
        </div>
        <div className={styles.imgsWrapper}>
          <div className={styles.row}>
            <div className={styles.label}>{TEXT}封面</div>
            <div className={styles.covers}>
              <div className={styles.horizon}>
                <UploadImg
                  onChange={onValueChange('cover_path')}
                  value={cover_path}
                  limitWidth={1080}
                  limitHeight={675}
                  aspect={1080 / 675}
                />
              </div>
              <div className={styles.vertical}>
                <VerticalImgUploader
                  limitWidth={limitWidth}
                  limitHeight={limitHeight}
                  title={`选取${TEXT}横图`}
                  horizonImg={(cover_path || {}).clipUrl}
                  value={(vertical_image || {}).clipUrl || ''}
                  onDelete={this.onVerticalDelete}
                  aspect={property_id == 12 ? 526 / 702 : 1 / 1}
                  height={120}
                  width={property_id == 12 ? 90 : 120}
                  afterCliped={({ data }) => {
                    checkImg.checkCMYK(1, data)
                  }}
                  onCliped={this.onVerticalCliped}
                  noUploadMark
                  description={
                    <div className={styles['upload_des']}>
                      <div className={styles['upload_add']}>+</div>
                      <p>{verticalImgText}</p>
                      <p>{property_id == 12 ? '526*702px' : '540*540px'}</p>
                    </div>
                  }
                  hidePlusIcon
                  autoCut
                  uploadConfig={{
                    // autoCut: true,
                    filters: {
                      mime_types: [
                        {
                          title: 'images files',
                          extensions: 'jpg,png,jpeg,bmp'
                        }
                      ],
                      max_file_size: '10mb',
                      prevent_duplicates: true
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>{TEXT}头图</div>
            <div className={styles.headImgs}>
              {/* <div className={styles.img}>图</div>
              <div className={styles.img}>图</div> */}
              <HeadImgList
                store={this.props.stepTwoStore}
                width={headImgWidth}
                height={headImgHeight}
              />
            </div>
          </div>
        </div>
      </Item>
    )
  }
}
